import {StyleSheet} from 'react-native';

import {
  black,
  cloud,
  cloudLight,
  onyx,
  onyxLighter,
  white,
} from '/theme/color/on.color';

export default StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  headerText: {
    fontSize: 18,
    fontWeight: '500',
  },
  goBackIcon: {
    marginLeft: -10,
  },
  scrollViewBase: {
    flex: 1,
  },
  contentWithFooter: {
    paddingBottom: 50,
  },
  errorBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FEE9E7',
    padding: 12,
    marginHorizontal: 16,
    marginTop: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#EC221F',
  },
  infoIcon: {
    fontSize: 20,
    color: '#900B09',
    marginRight: 10,
  },
  errorBannerText: {
    fontSize: 14,
    color: '#900B09',
    fontWeight: '400',
    flex: 1,
  },
  stickyFooter: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: white,
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingTop: 12,
    paddingBottom: 34,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    shadowColor: black,
    shadowOffset: {width: 0, height: -3},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 8,
  },
  footerCancel: {
    flex: 1,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    borderRadius: 6,
  },
  footerCancelText: {
    color: '#1C1C1E',
    fontSize: 16,
  },
  footerSave: {
    flex: 1,
    height: 48,
    backgroundColor: '#2C2C2C',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
    borderRadius: 30,
  },
  footerSaveText: {
    color: white,
    fontWeight: '700',
    fontSize: 16,
  },
  disabledBtn: {
    opacity: 0.5,
    backgroundColor: cloud,
  },
  section: {
    backgroundColor: white,
    padding: 20,
    marginBottom: 12,
    borderRadius: 8,
    marginHorizontal: 16,
    marginTop: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: onyx,
    marginBottom: 16,
    textTransform: 'uppercase',
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: onyxLighter,
    marginBottom: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: cloudLight,
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: onyx,
    backgroundColor: white,
  },
  errorText: {
    color: '#900B09',
    fontWeight: '400',
    fontSize: 16,
    marginTop: 4,
  },
  containerOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    borderRadius: 8,
    zIndex: 10,
  },
});
